<template>
  <main class="flex-1 flex flex-col overflow-hidden">
    <Header :title="'自定義活動列表'" @childLang="useLang" @toggleSidebar="$emit('toggleSidebar')">
      <div class="ml-8 text-gray-700">
        廣告來源：
      </div>
      <div class="flex mx-1 text-gray-400 w-auto">
        <img src="https://private.autoturn.net/img/facebook_icon.png" class="mr-2" width="28"/>
        <template v-for="(item, index) in metaAccountOptions" :key="index">
          <span v-if="item.code == metaViewAccountSelect" class="truncate">{{item.name}}</span>
        </template>
        <!-- <Dropdown
          v-model="fromAccountSelect"
          optionLabel="name"
          optionValue="code"
          :options="fromAccountOptions"
          :placeholder="showLang[selectLang]['views']['List']['advertise_account_dropdown_placeholder']"
          class="w-36 ml-2s rounded-md"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
        >
          <template #value="slotProps">
            <div v-if="slotProps.value" class="flex align-items-center">
              <img v-if="slotProps.value == 'facebook'" :alt="slotProps.value" width="28" src="https://private.autoturn.net/img/facebook_icon.png"/>
              <img v-if="slotProps.value == 'tiktok'" class="mt-0.5 mr-0.5 mb-0.5" :alt="slotProps.value" width="25" src="https://private.autoturn.net/img/tiktok_icon.png"/>
              <div v-if="slotProps.value == 'facebook'" class="leading-7">Facebook</div>
              <div v-if="slotProps.value == 'tiktok'" class="leading-7">Tiktok</div>
            </div>
            <span v-else>
                {{ slotProps.placeholder }}
            </span>
          </template>
          <template #option="slotProps">
            <div class="flex align-items-center">
              <img v-if="slotProps.option.code == 'facebook'" class="-ml-0.5" :alt="slotProps.option.name" width="28" src="https://private.autoturn.net/img/facebook_icon.png"/>
              <img v-if="slotProps.option.code == 'tiktok'" class="mt-0.5 mr-0.5 mb-0.5" :alt="slotProps.option.name" width="25" src="https://private.autoturn.net/img/tiktok_icon.png"/>
              <div class="leading-7">{{ slotProps.option.name }}</div>
            </div>
          </template>
        </Dropdown> -->
      </div>
      <!-- <div v-if="dataType == 'facebook'" class="mx-2 lg:mx-4 text-gray-700 text-sm lg:text-base">
        {{showLang[selectLang]['views']['List']['advertise_account_text']}}
      </div> -->
      <div v-show="false" class="flex mx-1 text-gray-400 border-l w-auto pl-4 ml-3">
        <img src="https://private.autoturn.net/img/tiktok_icon.png" class="mt-0.5 mr-2 mb-0.5" width="25"/>
        <template v-for="(item, index) in tiktokAccountOptions" :key="index">
          <span v-if="item.code == tiktokViewAccountSelect" class="truncate">{{item.name}}</span>
        </template>
        <!-- <Dropdown
          v-model="metaAccountSelect"
          optionLabel="name"
          optionValue="code"
          :options="metaAccountOptions"
          :placeholder="showLang[selectLang]['views']['List']['advertise_account_dropdown_placeholder']"
          class="w-52 ml-2s rounded-md h-12 leading-8"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
          filter
          @change="campaign(metaAccountSelect)"
        /> -->
      </div>
      <span
        class="focus:outline-none rounded-xl leading-9 px-4 py-1 text-gray-500 transition duration-500 text-sm text-blue-300 ease-in-outh-12 font-bold cursor-pointer"
        @click="showSetting = !showSetting"
      >
        修改
      </span>
      <!-- <div v-show="showSetting" class="absolute z-50 text-center" style="width: 500px; left: 625px; top:50px;"> -->
      <div v-show="showSetting" class="absolute z-50 text-center" style="width: 500px; left: 450px; top:50px;">
        <ShadowBox :padding="false" style="padding: 0px;">
          <div class="grid grid-cols-12 p-4">
            <div class="col-span-4 h-12 pl-2 text-left text-xl" style="line-height:2.5rem;">
              廣告來源
            </div>
            <div class="col-span-6" style="line-height:48px;"></div>
            <div class="col-span-2">
              <div class="p-2 text-white text-xs rounded-md cursor-pointer w-12 float-right" style="background-color: #2196F3;" @click="selectedAdaccount">
                儲存
              </div>
            </div>
            <div class="col-span-4 text-left grid grid-cols-12">
              <img src="https://private.autoturn.net/img/facebook_icon.png" class="mt-3 col-span-2" width="30"/>
              <div class="col-span-10 ml-1" style="line-height:3rem;">Facebook</div>
            </div>
            <div class="col-span-6" style="line-height:48px;">
              <Dropdown
                v-model="metaAccountSelect"
                optionLabel="name"
                optionValue="code"
                :options="metaAccountOptions"
                :placeholder="showLang[selectLang]['views']['List']['advertise_account_dropdown_placeholder']"
                class="w-52 ml-2s rounded-md h-10 leading-5"
                style="border: 1px solid #E2E5E9; color: rgb(53, 102, 165);"
                filter
              />
            </div>
            <div class="col-span-2 text-right">
              <span class="text-xs">執行中活動數</span>
              <span v-if="metaUseNum != 999" class="text-sm"><span style="color:#2196F3;">{{metaRunNum}}</span>/{{metaUseNum}}</span>
              <span v-else class="text-sm"><span style="color:#2196F3;">{{metaRunNum}}</span></span>
            </div>
            <div v-show="false" class="col-span-4 text-left grid grid-cols-12">
              <img src="https://private.autoturn.net/img/tiktok_icon.png" class="mt-3 col-span-2" width="25"/>
              <div class="col-span-10 ml-1" style="line-height:3rem;">Tiktok</div>
            </div>
            <div v-show="false" class="col-span-6" style="line-height: 48px;">
              <Dropdown
                v-model="tiktokAccountSelect"
                optionLabel="name"
                optionValue="code"
                :options="tiktokAccountOptions"
                :placeholder="showLang[selectLang]['views']['List']['advertise_account_dropdown_placeholder']"
                class="w-52 ml-2s rounded-md h-10 leading-5"
                style="border: 1px solid #E2E5E9; color: rgb(53, 102, 165);"
                filter
              />
            </div>
            <div v-show="false" class="col-span-2 text-right">
              <span class="text-xs">執行中活動數</span>
              <span class="text-sm"><span style="color:#2196F3;">{{tiktokRunNum}}</span>/{{tiktokUseNum}}</span>
            </div>
          </div>
        </ShadowBox>
      </div>
    </Header>
    <section v-if="false" class="flex justify-between items-center py-2 px-2 bg-white">
      <button
        class="bg-yellow-300 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 ml-4 text-blue-800 transition duration-500 ease-in-out border-2 border-yellow-400 mr-2 text-sm lg:text-base"
        :class="{ 'ring-4 border-blue-400': nowStep === 10 || nowStep === 90 }"
        :style="nowStep == 10 || nowStep == 90 ? { zIndex: 100, position: 'relative' } : null"
        :disabled="isUes"
        @click="createCampaign()"
      >
        {{createText}}
      </button>
    </section>

    <!-- <section class="flex overflow-x-hidden bg-gray-200"> -->
    <section class="flex bg-gray-200">
      <main id="edit_content" ref="scrollcontent" class="w-11/12 mx-auto pt-3 pr-16 overflow-y-scroll flex flex-row flex-wrap" style="height: 85vh;">
        <CustTemplateList :title="`${showLang[selectLang]['views']['List']['events_list_chart_title']}`" v-bind:adAccountId="metaViewAccountSelect+'___'+tiktokViewAccountSelect" v-bind:tiktokViewAccountSelect="tiktokViewAccountSelect" v-bind:lang="showLang[selectLang]"/>

        <div class="w-full flex flex-row flex-wrap items-start mt-3" :style="nowStep == 9 || nowStep == 90 ? { zIndex: 100, position: 'relative' } : null">
          <ListDataTable v-bind:showTable="showTable" v-bind:selecdedCurrency="metaSelecdedCurrency" v-bind:viewDatalist="campaignListData" v-bind:fromAccountSelect="fromAccountSelect" v-bind:parentMemberInfo="memberInfo" v-bind:lang="showLang[selectLang]" v-bind:useExperienceCustomize="useExperienceCustomize"/>
        </div>
      </main>
    </section>
  </main>

  <div v-if="nowStep >= 7 && nowStep <= 9 || nowStep == 90" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0); z-index: 1100;"></div>

  <Mask :isDisplay="nowStep > -1" />
  <ListMask
    v-if="nowStep >= 7 && nowStep <= 10 || nowStep == 90"
    :nowStep="nowStep"
    :selectLang="selectLang"
    @nextStep="nextStep"
    @closeTips="closeTips"
  />
</template>

<script>
import Mask from '@/components/Event/Mask.vue';
import ListMask from '@/components/Mask/ListMask.vue';

import Dropdown from 'primevue/dropdown'
import ShadowBox from "@/components/ShadowBox.vue";
import Header from '@/components/Header.vue'
import CustTemplateList from '@/components/CustomizeList/CustTemplateList.vue'
import ListDataTable from '@/components/CustomizeList/ListDataTable.vue'
import TikTokListDataTable from '@/components/TikTokList/ListDataTable.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import axios from 'axios'
import Qs from 'qs'
import lang from '@/language/lang.json'
import tiktokLang from '@/language/tiktok_lang.json'

// import { ref } from 'vue';

export default {
  name: 'CustomizeList',
  components: {
    Mask,
    ListMask,
    Header,
    Dropdown,
    ShadowBox,
    CustTemplateList,
    ListDataTable,
    TikTokListDataTable,
  },
  props: {
    getFirstLoginStatus: {
      type: Array
    },
    getTransmitFbNum: {
      type: String,
      default: ''
    },
    getTransmitTiktokNum: {
      type: String,
      default: ''
    },
  },
  setup() {

  },
  data() {
    return {
      selectLang: 'zh-TW',
      showLang: lang,
      showTiktokLang: tiktokLang,
      nowStep: -1,
      fromAccountSelect: 'facebook',
      fromAccountOptions: [{"name":"Facebook","code":"facebook"},{"name":"Tiktok","code":"tiktok"}],
      dataType: 'facebook',
      metaViewAccountSelect: '',
      metaAccountSelect: '',
      metaAccountOptions: [],
      metaSelecdedCurrency: null,
      metaRunNum: '-',
      metaUseNum: '-',
      tiktokViewAccountSelect: '',
      tiktokAccountSelect: '',
      tiktokAccountOptions: [],
      tiktokSelecdedCurrency: null,
      tiktokRunNum: '-',
      tiktokUseNum: '-',
      allLoading: true,
      showChart: false,
      showCloud: false,
      showTable: false,
      eventSelect: '',
      eventOptions: [],
      tableData: [],
      campaignListData: [],
      run_info: '-/-',
      createText: '請稍候...',
      isUes: true,
      member_source: 0,
      memberInfo: {
        status: 'y',
        plan_id: 1,
        source: 0,
      },
      showSetting:false,
      useExperienceCustomize: false,
    }
  },
  created() {
  //  console.log('list created');

    let _tmp_params_id = this.$route.params.id;
    let _tmp_hash = _tmp_params_id.split("_");
    let hash = _tmp_hash[0];
    let link_type = _tmp_hash.pop();
    let routeType = this.$route.params.type;

  //  console.log(_tmp_hash);
  //  console.log(hash);
  //  console.log(link_type);

  //  console.log('router type');
  //  console.log(routeType);

    if(routeType != '' && routeType != null && typeof routeType != 'undefined'){
      if(routeType == 't'){
        this.fromAccountSelect = 'tiktok';
        this.dataType = 'tiktok';
      }
    }

    if(hash != '' && hash != null && typeof hash != 'undefined'){
    //  console.log('props this.getFirstLoginStatusData');
    //  console.log(this.getFirstLoginStatusData);

      // axios
      //   .post('https://www.autoturn.net/api/member_info.php', Qs.stringify({
      //     s_code: hash,
      //   }))
      //   .then((adResponse) => {
      //     // console.log('adResponse:'+adResponse.data.selecded_data);
      //   //  console.log('list member_info.php');
      //     if(adResponse.data.status == 'success'){
      //       if(adResponse.data.return_data.first_login == 'Y'){
      //         this.nowStep = 7;
      //       }
      //     }
      //   });

    //  console.log('created fromAccountSelect');
    //  console.log(this.fromAccountSelect);

      axios
        .post('https://www.autoturn.net/api/member_info.php', Qs.stringify({
          s_code: this.$route.params.id,
        }), {withCredentials: true})
        .then((adResponse) => {
          // console.log('adResponse:'+adResponse.data.selecded_data);
        //  console.log('sidebar member_info.php');
          if(adResponse.data.status == 'success'){

            this.useExperienceCustomize = adResponse.data.return_data.use_experience_customize;

            axios
              .post('https://www.autoturn.net/api/customize/campaign/campaign_adaccounts.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
              }))
              .then((adResponse) => {
                // console.log('adResponse:'+adResponse.data.selecded_data);
                if(adResponse.data.status == 'success'){
                  if(adResponse.data.meta_return_data.length > 0){
                  //  console.log('this.metaAccountOptions');
                  //  console.log(this.metaAccountOptions);

                    this.metaAccountOptions = adResponse.data.meta_return_data
                    this.metaViewAccountSelect = adResponse.data.meta_selecded_data
                    this.metaAccountSelect = adResponse.data.meta_selecded_data
                    this.metaSelecdedCurrency = adResponse.data.meta_selecded_currency
                    this.metaRunNum = adResponse.data.meta_run_num
                    this.metaUseNum = adResponse.data.meta_use_num

                    this.tiktokAccountOptions = adResponse.data.tiktok_return_data
                    this.tiktokViewAccountSelect = adResponse.data.tiktok_selecded_data
                    this.tiktokAccountSelect = adResponse.data.tiktok_selecded_data
                    this.tiktokSelecdedCurrency = adResponse.data.tiktok_selecded_currency
                    this.tiktokRunNum = adResponse.data.tiktok_run_num
                    this.tiktokUseNum = adResponse.data.tiktok_use_num

                    this.createText = this.showLang[this.selectLang]['views']['List']['create_campaign_button_text'];
                    this.isUes = false;

                    if(this.dataType == 'tiktok'){
                      this.createText = this.showLang[this.selectLang]['views']['List']['create_tiktok_campaign_button_text'];
                    }

                    // console.log('created this.selecdedCurren:'+this.selecdedCurren);

                    // console.log('this.metaAccountSelect');
                    // console.log(this.metaAccountSelect);

                    axios
                      .post('https://www.autoturn.net/api/data/campaign_example_copy.php', Qs.stringify({
                        s_code: this.$route.params.id
                      }))
                      .then((response) => {
                        axios
                          .post('https://www.autoturn.net/api/customize/campaign/campaign_list.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            adaccount_id: this.metaViewAccountSelect+'___'+this.tiktokViewAccountSelect,
                          }))
                          .then((caResponse) => {
                            // console.log('caResponse:'+caResponse.data.return_data);
                            if(caResponse.data.status == 'success'){
                              this.campaignListData = caResponse.data.return_data
                            }

                            this.showTable = true;
                          });
                      });

                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['swal_title'],
                      text: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['swal_text'],
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['axios']['success_else']['confirm_button']
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                      } else if (result.isDenied) {
                        window.location.href = "https://private.autoturn.net/"+routeType+"/"+hash;
                      }
                    })
                  }
                }
              });

          } else {
            Swal.fire({
              icon: 'error',
              title: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_title'],
              text: adResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['else']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              }
            })
          }
        });


    } else {
      Swal.fire({
        icon: 'error',
        title: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_title'],
        text: this.showLang[this.selectLang]['views']['List']['created']['else']['swal_text'],
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: this.showLang[this.selectLang]['views']['List']['created']['else']['confirm_button']
        // denyButtonText: `Don't save`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          // Swal.fire('Saved!', '', 'success')
          // this.allPageLoading = true
          window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
        } else if (result.isDenied) {
          // Swal.fire('Changes are not saved', '', 'info')
          // this.allPageLoading = true
          window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
        }
      })
    }
  },
  watch:{
    'getFirstLoginStatus': function(v){
    //  console.log('watch getFirstLoginStatus');
    //  console.log(v);
      if(v.data.return_data.first_login != '' && v.data.return_data.first_login != null && typeof v.data.return_data.first_login != undefined){
        if(v.data.return_data.first_login == 'Y'){
          axios
            .post('https://www.autoturn.net/api/data/campaign_example_copy.php', Qs.stringify({
              s_code: this.$route.params.id
            }))
            .then((response) => {
              axios
                .post('https://www.autoturn.net/api/campaign_list.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.metaAccountSelect,
                }))
                .then((caResponse) => {
                  // console.log('caResponse:'+caResponse.data.return_data);
                  if(caResponse.data.status == 'success'){
                    this.campaignListData = caResponse.data.return_data
                  }
                });
            });

          this.nowStep = 7;
        }
      }
    }
  },
  methods: {
    selectedAdaccount(){
      let hash = this.$route.params.id;

      this.metaViewAccountSelect = this.metaAccountSelect;
      this.tiktokViewAccountSelect = this.tiktokAccountSelect;
      this.showSetting = false;
      this.showTable = false;

      axios
        .post('https://www.autoturn.net/api/customize/campaign/campaign_list.php', Qs.stringify({
          s_code: hash,
          adaccount_id: this.metaViewAccountSelect+'___'+this.tiktokViewAccountSelect,
        }))
        .then((caResponse) => {
          // console.log('caResponse:'+caResponse.data.return_data);
          if(caResponse.data.status == 'success'){
            this.campaignListData = caResponse.data.return_data
          }

          this.showTable = true;
        });
    },
    useLang(v){
    //  console.log('list methods useLang');
    //  console.log(v);

      if(v == '' || v == null || typeof v == 'undefined'){
        v = 'zh-TW';
      }

      this.selectLang = v

      this.$emit('childLang', v);

    //  console.log('this.selectLang');
    //  console.log(this.selectLang);
      // console.log('showLang['+v+'][msg]');
      // console.log(this.showLang[v]['msg']);

      document.title = this.showLang[this.selectLang]['views']['List']['page_name']+' - AutoTurn';
      if(this.dataType == 'tiktok'){
        document.title = this.showLang[this.selectLang]['views']['List']['tiktok_page_name']+' - AutoTurn';
      }
    },
    onCancel(){
      // console.log('onCancel');
      this.allLoading = false;
    },
    campaign(value){
    //  console.log('campaign');
    //  console.log(this.fromAccountSelect);
      this.showChart = false;
      this.showCloud = false;
      this.showTable = false;

      if(this.fromAccountSelect == 'facebook'){
        axios
          .post('https://www.autoturn.net/api/campaign_adaccounts.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: value,
          }))
          .then((adResponse) => {
            if(adResponse.data.status == 'success'){
              this.metaSelecdedCurrency =  adResponse.data.meta_selecded_currency
            }
          });

        axios
          .post('https://www.autoturn.net/api/campaign_list.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: value,
          }))
          .then((caResponse) => {
            // console.log(caResponse.data);
            if(caResponse.data.status == 'success'){
              this.campaignListData = caResponse.data.return_data
            }

            this.showTable = true;
          });

      } else {
        axios
          .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_adaccounts.php', Qs.stringify({
            s_code: this.$route.params.id,
            advertiser_id: value,
          }))
          .then((adResponse) => {
            // console.log('adResponse:'+adResponse.data.selecded_data);
            if(adResponse.data.status == 'success'){
              if(adResponse.data.return_data.length > 0){
                // this.metaAccountOptions = adResponse.data.meta_return_data
                // this.metaAccountSelect = adResponse.data.meta_selecded_data
                this.metaSelecdedCurrency =  adResponse.data.meta_selecded_currency

                // this.createText = this.showLang[this.selectLang]['views']['List']['create_campaign_button_text'];
                // this.isUes = false;

                axios
                  .post('https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_list.php', Qs.stringify({
                    s_code: this.$route.params.id,
                    advertiser_id: value,
                  }))
                  .then((caResponse) => {
                    // console.log('caResponse:'+caResponse.data.return_data);
                    if(caResponse.data.status == 'success'){
                      this.campaignListData = caResponse.data.return_data
                    }

                    this.showTable = true;
                  });

              }
            }
          });
      }
    },
    createCampaign(){
      let member_hash = this.$route.params.id
      let adaccount_id = this.$route.params.adaccount_id

      axios
        .post('https://www.autoturn.net/api/customize/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: this.$route.params.type,
          active: 'add',
          use_exp_cust: this.useExperienceCustomize,
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/customize-events-list/"+this.$route.params.type+"/"+member_hash+"/"+this.metaAccountSelect;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/customize-events-list/"+this.$route.params.type+"/"+member_hash+"/"+this.metaAccountSelect;
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/"+this.$route.params.type+"/"+member_hash;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://private.autoturn.net/"+this.$route.params.type+"/"+member_hash;
                }
              })
            } else {
              Swal.fire(
                        this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['error']['swal_title'],
                        caResponse.data.info,
                        caResponse.data.status
                      )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['warning']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              axios
                .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  status: 'N',
                }))
                .then((adResponse) => {
                  window.location.href = "https://private.autoturn.net/customize-event-add/"+this.$route.params.type+"/"+this.$route.params.id+"/"+this.metaAccountSelect;
                });
            });
          }

          if(caResponse.data.status == 'success'){
            axios
              .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
                s_code: this.$route.params.id,
                status: 'N',
              }))
              .then((adResponse) => {
                window.location.href = "https://private.autoturn.net/customize-event-add/"+this.$route.params.type+"/"+this.$route.params.id+"/"+this.metaAccountSelect;
              });
          }

          if(caResponse.data.status == 'login'){
            Swal.fire({
              icon: 'error',
              title: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['login']['swal_title'],
              text: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['login']['swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['List']['methods']['createCampaign']['axios']['login']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
              }
            })
          }
        });
    },
    nextStep() {
      this.nowStep = this.nowStep + 1;      
    //  console.log('list this.nextStep');
    //  console.log(this.nowStep);

      if(this.nowStep == 9 && this.member_source == 6){
        this.nowStep = 90;

        this.$refs.scrollcontent.scrollTo({
          top: 500,
          behavior: 'smooth'
        });
      } else if(this.nowStep == 9){
        this.$refs.scrollcontent.scrollTo({
          top: 500,
          behavior: 'smooth'
        });
      } else if(this.nowStep == 10) {
        this.$refs.scrollcontent.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    closeTips() {        
      this.nowStep = -1;
    //  console.log('closeTips');
    //  console.log(this.nowStep);

      axios
        .post('https://www.autoturn.net/api/data/first_login_update.php', Qs.stringify({
          s_code: this.$route.params.id,
          status: 'N',
        }))
        .then((adResponse) => {});
    },
    getTransmitTiktokNum(v){
    //  console.log('watch getTransmitTiktokNum');
    //  console.log(v);
    //  console.log(this.transmitTiktokNum);
      this.transmitTiktokNum = v;
    //  console.log(this.transmitTiktokNum);
    },
  },
  mounted () {
    // document.title = '行銷活動列表 - AutoTurn';
  },
  computed: {
    getFirstLoginStatusData: {
      get: function () {
        return this.getFirstLoginStatus
      },
      set: function (value) {
        this.$emit('update:getFirstLoginStatusData', value)
      },
    },
  }
}

</script>

<style lang="scss" scoped>

</style>